<template>
  <div class="order-item">
    <div class="order-item-tile">
      <div class="order-id">
        <router-link :to="{ name: 'myOrder', params: { id: order.entity_id } }">
          <span class="text">{{order.increment_id}}</span>
        </router-link>
      </div>
      <div class="order-email">
        <svg class="o-icon fill-black"><use xlink:href="#email-outline"></use></svg>
        <span class="text">{{order.customer_email}}</span>
      </div>
      <div class="order-items-count">
        <span class="text">{{order.total_item_count}}</span>
      </div>
      <div class="order-status">
        <div class="order-badge-status" :class="[`order-status-${order.status}`]"></div>
        <span class="text">{{$t(`order-status.${order.status}`)}}</span>
      </div>
      <div class="order-created">
        <span class="text">{{createdAt}}</span>
      </div>
      <div class="order-totals">
        <span class="text">{{orderTotal}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { price } from '@/filters'

export default {
  name: 'OrderTile',
  props: {
    order: {
      type: Object,
      required: true
    },
    inputText: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    createdAt () {
      if (this.order && this.order.created_at) {
        return dayjs(this.order.created_at).format('DD/MM/YYYY')
      } else {
        return false
      }
    },
    orderTotal () {
      if (this.order) {
        return price(this.order.total_due, this.$store)
      } else {
        return 0
      }
    }
  }
}
</script>
